import { BaseProjectProps } from "@custom-types/project-types";
import { DeleteProject } from "@pages/project-details/project-overview/delete-project";
import { ActionButtonMenuItem, VerticalDotsMenu } from "@components/action-buttons/vertical-dots-menu";
import { useProjectActions } from "@hooks/projects/use-project-actions";
import { useState } from "react";
import ArchiveIcon from "@assets/icons/Archive.svg?react";
import UnarchiveIcon from "@assets/icons/Unarchive.svg?react";
import { SvgIconProps } from "@mui/material";
import { DeleteIcon, FaroIconButtonSizes, FaroSvgIcon, ShareLinkIcon } from "@faro-lotv/flat-ui";
import { sphereColors } from "@styles/common-colors";

/**
 *  Provides actions buttons for project details page in a compact version.
 */
export function ResponsiveProjectButtons({
  project,
}: BaseProjectProps): JSX.Element | null {
  const [shouldShowDeleteDialog, setShouldShowDeleteDialog] =
    useState<boolean>(false);
  const {
    handleShareProject,
    archiveOrUnarchiveProject,
    canDeleteProject,
    archiveActionLabel,
    isProjectActive,
  } = useProjectActions(project);

  const menuItems: ActionButtonMenuItem[] = [
    {
      label: archiveActionLabel,
      Icon: (props: SvgIconProps) => {
        const stateIcon = isProjectActive ? ArchiveIcon : UnarchiveIcon;
        return <FaroSvgIcon source={stateIcon} {...props} />;
      },
      onClick: archiveOrUnarchiveProject,
      isVisible: true,
    },
    {
      label: "Share",
      Icon: ShareLinkIcon,
      onClick: handleShareProject,
      isVisible: true,
    },
    {
      type: "separator",
      isVisible: !isProjectActive && canDeleteProject,
      label: "",
    },
    {
      label: "Delete",
      Icon: DeleteIcon,
      onClick: () => setShouldShowDeleteDialog(true),
      color: sphereColors.red600,
      highlightColor: sphereColors.red600,
      isVisible: !isProjectActive && canDeleteProject,
    },
  ];

  return (
    <>
      <VerticalDotsMenu menuItems={menuItems} size={FaroIconButtonSizes.m} />
      {/* Delete Confirmation Dialog */}
      {shouldShowDeleteDialog && (
        <DeleteProject
          project={project}
          onClose={() => setShouldShowDeleteDialog(false)}
        />
      )}
    </>
  );
}